"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = exports.isValid = exports.getErrors = exports.Model = exports.ValidationError = void 0;
require("reflect-metadata");
const validator = __importStar(require("class-validator"));
const transformer = __importStar(require("class-transformer"));
// Errors are embedded on the model instance with this key.  A leading _ is
// required as those are treated at internal properties that are not exposed.
const ERRORS_KEY = '_errors';
/**
 * Thrown when one or more validation errors are encountered.
 */
class ValidationError extends Error {
    /**
     *
     * @param errors Array of errors
     */
    constructor(errors) {
        super();
        this.errors = errors;
    }
}
exports.ValidationError = ValidationError;
/**
 *
 * Create custom data models by subclassing this class.  To create
 * new instances use the `load` method.
 *
 */
class Model {
    constructor() {
        //
        // HACK: We're hiding this so that typescript can't see it but when
        //       JSON.stringify is called with an instance of a Model, it'll still
        //       work properly
        //
        Object.defineProperty(this, 'toJSON', {
            value: (options) => {
                const opts = Object.assign(Object.assign({}, options), { excludePrefixes: ['_'] });
                return transformer.classToPlain(this, opts);
            },
            writable: false,
            enumerable: false,
        });
    }
    /**
     *
     * Load an instance of this model.  When using this library in typescript,
     * this method should typically be used over {@linkcode Model.raw | raw}
     * because it applies typings to the incoming data.
     *
     */
    static load(data, options = {}) {
        // If the incoming object is already an instance of this model, just check
        // for previous validation errors
        if (data instanceof this) {
            const errors = (0, exports.getErrors)(data);
            if (errors.length > 0) {
                throw new ValidationError(errors);
            }
            return data;
        }
        return this.raw(data, options);
    }
    /**
     *
     * Load an instace of this model from an unknown data object.
     * Use this when data is coming from somewhere and the structure
     * of the data is unknown.  For all other use cases, it is probably
     * better to use {@linkcode Model.load} instead.
     *
     */
    static raw(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data, 
    //
    // TODO: Get safeMode=false working as default
    //
    options = { safeMode: true }) {
        const validatorOptions = Object.assign({ whitelist: true }, options.validateOpts);
        const transformOptions = Object.assign({ exposeDefaultValues: true }, options.transformOpts);
        if (options.skipDefaults !== true) {
            // TODO: Unset keys from this.defaults that are not defined on this model
            data = Object.assign(Object.assign({}, this.defaults), data);
        }
        // If we're running in safeMode, then we run the incoming data
        // throught a JSON serialization -> deserialization process, otherwise
        // we pass the data object straight through.
        const preprocess = (data) => options.safeMode === true ? JSON.parse(JSON.stringify(data)) : data;
        // Perform the actual transformation operation
        const instance = transformer.plainToClass(this, preprocess(data), transformOptions);
        // Run the validation in synchronous mode and collect the errors
        const errors = validator.validateSync(instance, validatorOptions);
        // Process any errors
        if (errors.length > 0) {
            // Set the errors but make them read-only and non-enumerable
            Object.defineProperty(instance, ERRORS_KEY, {
                value: errors,
                writable: false,
                enumerable: false,
            });
            // If not in silentMode, we need to throw an error
            if (options.silent !== true) {
                // User-supplied error class
                if (options.throwableErrorClass) {
                    throw new options.throwableErrorClass('invalid-argument', errors.map(e => e.toString()).join(', '));
                }
                //console.log(errors)
                //console.log(errors.map(e => e.toString()).join(', '));
                // Fall back to using ValidationError
                throw new ValidationError(errors);
            }
        }
        return instance;
    }
    /**
     * Perform a partial transform and validation operation on the provided data.
     * This might be useful if you want to perform an update operation on an
     * existing document.  For example:
     *
     *  const postUpdate = Post.partial({
     *   name: 'Post Title',
     *   updatedAt: DateTime.utc(),
     *  });
     *
     *  firebase.firestore().doc('posts/post-1').update(serialize(postUpdate));
     *
     * NOTE: This is currently in an experimental status--use with caution.
     */
    static partial(data, options = {}) {
        const validatorOptions = Object.assign({ skipMissingProperties: true }, options.validateOpts);
        // Setting `exposeDefaultValues` to false doesn't actually stop
        // default values from being added (why??)...so, below we remove any keys
        // that are on the resulting object that are not present on the passed
        // data object.
        const transformOptions = Object.assign({ exposeDefaultValues: false }, options.transformOpts);
        options = Object.assign(Object.assign({}, options), { validateOpts: validatorOptions, transformOpts: transformOptions });
        const partial = this.raw(data, options);
        const keys = Object.keys(data);
        // TODO: In order to be fully compliant with the shape of the input data,
        // this needs a recursive implementation that traverses through any
        // objects or arrays...
        Object.keys(partial).forEach(key => {
            if (keys.indexOf(key) < 0) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                delete partial[key];
            }
        });
        const obj = Object.assign({}, partial);
        // Make the object 'serializable', but hide the toJSON method
        Object.defineProperty(obj, 'toJSON', {
            value: () => (0, exports.serialize)(partial),
            enumerable: false,
            writable: false,
            configurable: false,
        });
        return obj;
    }
}
exports.Model = Model;
Model.defaults = {};
/**
 *
 * When validation is in {@linkcode ModelLoadOptions.silent | silent} mode,
 * this can be used to retrieve any validation errors.
 *
 */
const getErrors = (model) => {
    const property = Object.getOwnPropertyDescriptor(model, ERRORS_KEY);
    let errors = [];
    if (property) {
        errors = property.value;
    }
    return errors;
};
exports.getErrors = getErrors;
/**
 *
 * When validation is in {@linkcode ModelLoadOptions.silent | silent} mode,
 * this checks to see if the model passed validation.
 *
 */
const isValid = (model) => {
    const errors = (0, exports.getErrors)(model);
    return errors.length === 0;
};
exports.isValid = isValid;
/**
 * Serializes the provided model into a JSON-friendly format.  If the provided
 * object isn't actually a model, an attempt will be made to convert it to a
 * plain Object anyway.
 */
const serialize = (model, opts = {}) => {
    const descriptor = Object.getOwnPropertyDescriptor(model, 'toJSON');
    if (descriptor) {
        return descriptor.value(Object.assign({ 
            // Hide any keys with undefined values
            exposeUnsetFields: false }, opts));
    }
    // Fallback to JSON serialize
    return JSON.parse(JSON.stringify(model));
};
exports.serialize = serialize;
//# sourceMappingURL=model.js.map